import React, { useEffect, useState } from "react";

// redux
import { history } from "../index";
import { connect } from "react-redux";
import { checkIsRegistration } from "../redux/ssh";
import { ConnectedRouter } from "connected-react-router";
import { Switch, Route, withRouter } from "react-router-dom";
import { getAuthorizationPermissions } from "../redux/auth/authActions";

// Components
import Ssh from "../components/ssh/Ssh";
import App from "../components/home/App";
import PrivateRoute from "./privateRoute";
import Login from "../components/auth/Login";
import AuthPage from "../components/auth/AuthPage";
import RecommendationsAuthPage from "../components/auth/RecommendationsAuthPage";
import ApprovalsAuthPage from "../components/auth/ApprovalsAuthPage";
import ServerReviewAuthPage from "../components/auth/ServerReviewAuthPage";
import ClientSSOAuthPage from "../components/auth/ClientSSOAuthPage";
import Error404 from "../components/error/Error404";
import FulfillmentUI from "../components/fui/FulfillmentUI";
import Ec2Management from "../components/ec2management/Ec2Management";
import CommonLayout from "../components/common/ComonLayout/CommonLayout";
import Faq from "../components/support/Faq";
import Admin from "../components/admin/AdminPage";
import AdminMainPage from "../components/admin/AdminMainPage";
import Recommendations from "../components/recommendations/Recommendations";
import AzureOpenAI from "../components/azureOpenAI/AzureOpenAI";
import ApprovalsTabWrapper from "../components/approvals/ApprovalsTabWrapper";
import ServerReview from "../components/serverReview/ServerReview";
import Metrics from "../components/metrics/Metrics";
import LicensePage from "../components/admin/LicensePage";
import ServerPage from "../components/ec2management/ServerPage";
import ExternalSSOStepper from "../components/sso/ExternalSSOStepper";
import SSORequestsList from "../components/admin/SSORequests/SSORequestsList";

const Routes = ({
  exp,
  email,
  isAuthenticated,
  checkIsRegistration,
  adRole,
  getAuthorizationPermissions,
  camPermissions,
}) => {
  const userRbac = JSON.parse(
    localStorage.getItem("userRoleBasedAccessControl")
  );


  const rbacFetchNotNeeded = userRbac !== null ? true : false;

  const [fetchedRBAC, setFetchedRBAC] = useState(rbacFetchNotNeeded);

  const currentCamPermissions =
    userRbac !== null ? userRbac.data : camPermissions;

  const componentRoutes = (name) => {
    switch (name) {
      case "ServerManagementComponent":
        return Ec2Management;
      case "FulfillmentUI":
        return FulfillmentUI;
      case "Ssh":
        return Ssh;
      case "Admin":
        // return Admin;
        return AdminMainPage;
      case "Recommendations":
        return Recommendations;
      case "AzureOpenAI":
        return AzureOpenAI;
      case "ServerReview":
        return ServerReview;
      default:
        return null;
    }
  };
  const auth = localStorage.getItem("isRegistered");
  const idToken = localStorage.getItem("token");

  useEffect(() => {
    exp && localStorage.setItem("exp", exp);
  }, [exp]);

  useEffect(() => {
    if (email) {
      checkIsRegistration(email, idToken);
      if (adRole && !fetchedRBAC) {
        getAuthorizationPermissions(email, adRole, idToken);
        setFetchedRBAC(true);
      }
    }
  }, [email, auth, adRole, fetchedRBAC]);

  return (
    <ConnectedRouter history={history}>
      <CommonLayout history={history} camPermissions={currentCamPermissions}>
        <Switch>
          <PrivateRoute
            path="/"
            exact
            isAuthenticated={isAuthenticated}
            component={App}
          />

          <PrivateRoute exact
            path="/recommendations"
            isAuthenticated={isAuthenticated}
            component={Recommendations}
          />

          <PrivateRoute exact
            path="/genwizard"
            isAuthenticated={isAuthenticated}
            component={AzureOpenAI}
          />

          <PrivateRoute exact
            path="/approvals"
            isAuthenticated={isAuthenticated}
            component={ApprovalsTabWrapper}
          />

          <PrivateRoute exact
            path="/serverReview"
            isAuthenticated={isAuthenticated}
            component={ServerReview}
          />

          <PrivateRoute exact
            path="/metrics"
            isAuthenticated={isAuthenticated}
            component={Metrics}
          />

          {/*

        <PrivateRoute path="/ssh/:type" component={Ssh} />
        */}
          <Route path="/login" component={withRouter(Login)} />
          <Route
            path="/AAAMTermsConditions"
            component={() =>
            (window.location =
              "https://mywizard-aiops.accenture.com/accenture-splunk-msp-license-usage-policy/")
            }
          />
          <Route
            path="/WikePage"
            component={
              () =>
              (window.location =
                "https://docs.oracle.com/en/cloud/paas/event-hub-cloud/admin-guide/generate-ssh-key-pair-using-ssh-keygen.html")
              // "https://dh.aiam.accenture.com/wiki/index.php/SSH_::_Generate_a_Key_Pair")
            }
          />
          <Route path="/404" component={Error404} />
          <Route exact path="/auth" component={AuthPage} />
          <Route exact path="/auth1" component={RecommendationsAuthPage} />
          <Route exact path="/auth2" component={ApprovalsAuthPage} />
          <Route exact path="/auth3" component={ServerReviewAuthPage} />
          <Route exact path="/auth4" component={ClientSSOAuthPage} />
          <Route path="/faq" component={Faq} />
          <Route exact path="/client-sso-integration" component={ExternalSSOStepper} />
          <Route exact path="/admin/sso-requests" component={SSORequestsList} />

          {/*<PrivateRoute path="/recommendations" isAuthenticated={isAuthenticated} component={Recommendations} /> */}


          {fetchedRBAC &&
            Object.keys(currentCamPermissions).length !== 0 &&
            currentCamPermissions[0].map(
              (ele, index) =>
                ele["component"] === "FulfillmentUI" && (
                  <PrivateRoute
                    path="/fui/:type/:routeName"
                    component={FulfillmentUI}
                    key={index}
                  />
                )
            )}

          {fetchedRBAC &&
            Object.keys(currentCamPermissions).length !== 0 &&
            currentCamPermissions[0].map((ele, index) =>
              <PrivateRoute
                path="/server/:type"
                component={ServerPage}
                key={index}
              />
            )
          }

          {fetchedRBAC &&
            Object.keys(currentCamPermissions).length !== 0 &&
            currentCamPermissions[0].map(
              (ele, index) =>
                ele["component"] === "AdminAccess" && (
                  <PrivateRoute
                    path="/admin/:type"
                    component={AdminMainPage}
                    key={index}
                  />
                )
            )}


          {fetchedRBAC &&
            Object.keys(currentCamPermissions).length !== 0 &&
            currentCamPermissions[0].map((ele, index) => (
              <PrivateRoute
                path={ele["url"]}
                component={componentRoutes(ele["component"])}
                key={index}
              />
            ))}

          {fetchedRBAC &&
            Object.keys(currentCamPermissions).length !== 0 &&
            currentCamPermissions[0].map(
              (ele, index) =>
                (ele["component"] === "LicenseManagementAdminAccess" || ele["component"] === "AdminAccess") && (
                  <PrivateRoute
                    path="/licensemanagement"
                    component={LicensePage}
                    key={index}
                  />
                )
            )}
          {fetchedRBAC &&
            Object.keys(currentCamPermissions).length !== 0 &&
            currentCamPermissions[0].map(
              (ele, index) =>
                ele["component"] === "AdminAccess" && (
                  <PrivateRoute exact
                    path="/metrics"
                    isAuthenticated={isAuthenticated}
                    component={Metrics}
                  />
                )
            )}

        </Switch>
      </CommonLayout>
    </ConnectedRouter>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    exp: state.auth.userDetails.exp,
    iat: state.auth.userDetails.iat,
    timeout: state.auth.timeout,
    email: state.auth.userDetails.email,
    adRole: state.auth.userDetails.profile,
    camPermissions: state.auth.camPermissions,
  };
};

const mapDispatchToProps = (dispatch) => ({
  checkIsRegistration: (email, idToken) => dispatch(checkIsRegistration(email, idToken)),
  getAuthorizationPermissions: (email, adRole, idToken) =>
    dispatch(getAuthorizationPermissions(email, adRole, idToken)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
